import React from "react";
import { MdEmail } from "react-icons/md";
import "../contact.css";

function Contact() {
  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <MdEmail className="email-icon" />
        <h2 className="contact-title">Get In Touch!</h2>
        <p className="contact-message">
          Whether you have an idea for a project or just want to chat,<br />
          feel free to shoot me an email!
        </p>
        <a
          href="mailto:mohammedshoaibplc@gmail.com"
          className="say-hello-btn"
        >
          Say Hello
        </a>

        <div className="connect">
          <h3>Connect with me:</h3>
          <div className="social-icons">
            <a
              href="https://www.instagram.com/yourusername"
              target="_blank"
              rel="noopener noreferrer"
              className="icon insta"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://wa.me/9108104726"
              target="_blank"
              rel="noopener noreferrer"
              className="icon whatsapp"
            >
              <i className="fab fa-whatsapp"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/mohammed-shoaib-423b35329"
              target="_blank"
              rel="noopener noreferrer"
              className="icon linkedin"
            >
              <i className="fab fa-linkedin"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
